import { useEffect } from "react";
import "./App.scss";
import RouteComponent from "./routes/route";
import { RootState } from "./store/reducers";
import Alert from "./components/Alert";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../src/store";
import { Route, Router, Routes, useNavigate, useParams } from "react-router";
import Invoice from "./screens/invoice/Invoice";
import NotFound from "./screens/404";

export default function App() {
  const dispatch = useDispatch();
  const appState = useSelector((state: RootState) => state.appReducer);
  const apiState = useSelector((state: RootState) => state.apiReducer);
  const { setBookingTotal } = bindActionCreators(actionCreators, dispatch);
  const navigate = useNavigate();
  const { slug, id } = useParams();
  useEffect(() => {
    if (appState?.cart) {
      let cartTotal = 0;
      let guest =  appState?.bookingForm?.slotsType == 1 ? appState?.bookingForm?.NoGuest : 1 ;
      let bookingPrice = appState?.bookingForm?.bookingPrice ?? 0;
      let slotPrice = appState?.bookingForm?.slotPrice ?? 0;
      console.log(appState?.bookingForm)
      // let reservationFee = Number(Number(bookingPrice) + Number(slotPrice)) * Number(guest);
      let reservationFee = Number(Number(bookingPrice) + Number(slotPrice)) * Number(guest);
      if (appState?.cart.length > 0) {
        appState?.cart.forEach((item: any) => {
          if(item?.multiple){
            cartTotal = cartTotal + ((Number(item?.quantity) * Number(item?.price)) * Number(guest));
          }else{
            cartTotal = cartTotal + (Number(item?.quantity) * Number(item?.price));
          }
        });
      }
      setBookingTotal({
        cartTotal: cartTotal,
        reservationFee: reservationFee,
        bookingPrice: bookingPrice,
        slotPrice: slotPrice,
        sumOfTotal: Number(cartTotal) + Number(reservationFee),
      });
    }
  }, [appState?.cart]);

 

  return (
    <div
      className={`App ${
        appState.langValue === "ar" ? "directionRtl_family" : ""
      }`}
    >

      
      {/* {appState.alert.show && <Alert />} */}
      <div className="container-fluid bg-img"  style={{
          backgroundImage: apiState.storeInfo?.bookingBackground
            ? `url(${apiState.storeInfo.bookingBackground})`
            : undefined,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: apiState.storeInfo?.bookingBackground ? "fixed" : undefined,
        }}>
        <div className="row justify-content-center">
          <div
            className="col-md-6 col-lg-5 px-0"
            style={
              apiState.storeInfo?.bookingBackground
                ? { background: "#fff", minHeight: "100vh" }
                : undefined
            }
          >
            <Alert />
            <Routes>
            <Route path="/:slug/*" element={<RouteComponent/>} />
            <Route path="/:slug/404" element={<NotFound/>} />
            </Routes>

            {/* <RouteComponent/> */}
          </div>
        </div>
      </div>
    </div>
  );
}
